"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "wasteBinReadings",
    path: "/waste-bin-readings",
    component: "WasteBinReadings"
});
let WasteBinReadings = class WasteBinReadings extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_dsParams = new core_1.ComponentValueCache(this, "dsParams", "WasteBinReadings.dsParams");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    selectedItems;
    dsParams;
    ds;
    async $$load_ds() {
        return this.$fn.slickDataSource('list_waste_bin_readings', { parameters: this.dsParams });
    }
    ux;
    b_7315092382398562_modalBindings;
    b_2248226175642056_columnDefaults;
    b_2248226175642056_columns;
    b_2248226175642056_contextMenu;
    dataMembers = ['selectedItems', 'dsParams', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns', 'b_2248226175642056_contextMenu'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                selectedItems: [],
                dsParams: {
                    include_worksheets: false,
                },
                ds: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_2248226175642056_columnDefaults: {
                    sortable: true,
                    filterable: true,
                    resizable: true,
                },
                b_2248226175642056_columns: [{
                        field: "timestamp",
                        name: this.$fn.pgettext("WasteBinReadings", "Reading Time"),
                        type: "command",
                        formatter: {
                            name: "chain",
                            formatters: [{
                                    name: "datetime",
                                },
                                {
                                    name: "link",
                                    href: "#",
                                    className: "command-link",
                                },
                            ],
                        },
                    },
                    {
                        field: "waste_bin_name",
                        name: this.$fn.pgettext("WasteBinReadings", "Bin Name"),
                        formatter: {
                            name: "routeLink",
                            to: "fixedAsset",
                            params: {
                                id: "waste_bin_id",
                            },
                        },
                    },
                    {
                        field: "waste_bin_number",
                        name: this.$fn.pgettext("WasteBinReadings", "Bin Number"),
                    },
                    {
                        field: "waste_bin_capacity",
                        name: this.$fn.pgettext("WasteBinReadings", "Capacity (liters)"),
                    },
                    {
                        field: "state",
                        name: this.$fn.pgettext("WasteBinReadings", "State"),
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "gettext",
                                    context: "WasteBinReadingStates",
                                    conversion: "StartCase",
                                },
                                {
                                    name: "badge",
                                    variantmap: {
                                        empty: "success",
                                        full: "warning",
                                    },
                                    variantMapSource: "fieldValue",
                                },
                            ],
                        },
                    },
                    {
                        field: "rental_name",
                        name: this.$fn.pgettext("WasteBinReadings", "Rental"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "rental",
                            params: {
                                id: "rental_id",
                            },
                        },
                    },
                    {
                        field: "client_number",
                        name: this.$fn.pgettext("WasteBinReadings", "Client Number"),
                        formatter: {
                            name: "routeLink",
                            to: "company",
                            params: {
                                id: "client_id",
                            },
                        },
                    },
                    {
                        field: "client_name",
                        name: this.$fn.pgettext("WasteBinReadings", "Client Name"),
                        formatter: {
                            name: "routeLink",
                            to: "company",
                            params: {
                                id: "client_id",
                            },
                        },
                    },
                    {
                        field: "cycle",
                        name: this.$fn.pgettext("WasteBinReadings", "Cycle"),
                    },
                    {
                        field: "device_id",
                        name: this.$fn.pgettext("WasteBinReadings", "Device ID"),
                    },
                    {
                        field: "worksheets",
                        name: this.$fn.pgettext("WasteBinReadings", "Worksheets"),
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            separator: ", ",
                            formatterContext: "item",
                            formatters: [{
                                    name: "getvalue",
                                    opts: {
                                        field: "number",
                                        source: "value",
                                    },
                                },
                                {
                                    name: "routeLink",
                                    to: "worksheet",
                                    params: {
                                        id: "id",
                                    },
                                },
                            ],
                        },
                    },
                ],
                b_2248226175642056_contextMenu: {
                    items: [{
                            label: this.$fn.gettext("Delete"),
                            command: "remove",
                        },
                    ],
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.gettext("Waste Bin Readings"),
                icon: this.$config.wasteBin.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_2008_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_setData_2010_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2248226175642056_selectedRowsChanged(event, scope) {
        return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_reloadSlickgrid_2014_getActionArgs($event) {
        return {
            grid: "wasteBinReadings",
        };
    }
    async act_2248226175642056_request_2012_getActionArgs($event) {
        return {
            operation: "waste_bins/delete_reading",
            data: { identities: [$event.data.data.id] },
        };
    }
    async evh_2248226175642056_contextmenuRemove(event, scope) {
        return await this.actions.evh_2248226175642056_contextmenuRemove.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_showModal_2016_getActionArgs($event) {
        return {
            name: "WasteBinReadingModal",
            props: {
                objectId: $event.data.data.id,
            },
        };
    }
    async evh_2248226175642056_command_2015_getWhen($event) {
        return $event.data.column.id === 'timestamp';
    }
    async evh_2248226175642056_command(event, scope) {
        return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
    }
    async act_8320016629450276_showModal_2018_getActionArgs($event) {
        return {
            name: "CreateWorksheetsFromWasteBinReadingsModal",
            props: {
                readings: _.map(this.selectedItems, p => p.id),
            },
        };
    }
    async evh_8320016629450276_click(event, scope) {
        return await this.actions.evh_8320016629450276_click.executeFromDOM(this, event, scope);
    }
    async act_6705964765214521_reloadSlickgrid_2022_getActionArgs($event) {
        return {
            grid: "wasteBinReadings",
        };
    }
    async act_6705964765214521_request_2020_getActionArgs($event) {
        return {
            operation: "waste_bins/delete_readings",
            data: { identities: this.selectedItems.map(p => p.id) },
        };
    }
    async act_6705964765214521_request_2020_getConfirm($event) {
        return {
            header: "_(\"Delete the selected readings?\")",
            message: this.$fn.gettext("This action cannot be undone."),
            btnOk: this.$fn.gettext("Delete"),
        };
    }
    async evh_6705964765214521_click(event, scope) {
        return await this.actions.evh_6705964765214521_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_2008 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_2008_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_2007 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_2008,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_2007],
        });
        const act_2248226175642056_setData_2010 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2248226175642056_setData_2010_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_selectedRowsChanged_2009 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_setData_2010,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_2248226175642056_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_selectedRowsChanged_2009],
        });
        const act_2248226175642056_reloadSlickgrid_2014 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_2248226175642056_reloadSlickgrid_2014_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_success_2013 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_reloadSlickgrid_2014,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_2248226175642056_request_2012 = new core_1.actions.RequestAction({
            actionArgs: this.act_2248226175642056_request_2012_getActionArgs,
            events: [evh_2248226175642056_success_2013],
        });
        const evh_2248226175642056_contextmenuRemove_2011 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_request_2012,
            event: "contextmenu:remove",
            displayName: "request",
        });
        const evh_2248226175642056_contextmenuRemove = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_contextmenuRemove_2011],
        });
        const act_2248226175642056_showModal_2016 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2248226175642056_showModal_2016_getActionArgs,
            displayName: "showWasteBinReadingModal",
            events: [],
        });
        const evh_2248226175642056_command_2015 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_showModal_2016,
            event: "command",
            when: this.evh_2248226175642056_command_2015_getWhen,
            displayName: "showWasteBinReadingModal",
        });
        const evh_2248226175642056_command = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_command_2015],
        });
        const act_8320016629450276_showModal_2018 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8320016629450276_showModal_2018_getActionArgs,
            events: [],
        });
        const evh_8320016629450276_click_2017 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_showModal_2018,
            event: "click",
            displayName: "showModal",
        });
        const evh_8320016629450276_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_click_2017],
        });
        const act_6705964765214521_reloadSlickgrid_2022 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_6705964765214521_reloadSlickgrid_2022_getActionArgs,
            events: [],
        });
        const evh_6705964765214521_success_2021 = new core_1.actions.EventHandlerImpl({
            action: act_6705964765214521_reloadSlickgrid_2022,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_6705964765214521_request_2020 = new core_1.actions.RequestAction({
            actionArgs: this.act_6705964765214521_request_2020_getActionArgs,
            confirm: this.act_6705964765214521_request_2020_getConfirm,
            displayName: "deleteItems",
            events: [evh_6705964765214521_success_2021],
        });
        const evh_6705964765214521_click_2019 = new core_1.actions.EventHandlerImpl({
            action: act_6705964765214521_request_2020,
            event: "click",
            displayName: "deleteItems",
        });
        const evh_6705964765214521_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6705964765214521_click_2019],
        });
        return {
            act_7315092382398562_closeModal_2008,
            evh_7315092382398562_close_2007,
            evh_7315092382398562_close,
            act_2248226175642056_setData_2010,
            evh_2248226175642056_selectedRowsChanged_2009,
            evh_2248226175642056_selectedRowsChanged,
            act_2248226175642056_reloadSlickgrid_2014,
            evh_2248226175642056_success_2013,
            act_2248226175642056_request_2012,
            evh_2248226175642056_contextmenuRemove_2011,
            evh_2248226175642056_contextmenuRemove,
            act_2248226175642056_showModal_2016,
            evh_2248226175642056_command_2015,
            evh_2248226175642056_command,
            act_8320016629450276_showModal_2018,
            evh_8320016629450276_click_2017,
            evh_8320016629450276_click,
            act_6705964765214521_reloadSlickgrid_2022,
            evh_6705964765214521_success_2021,
            act_6705964765214521_request_2020,
            evh_6705964765214521_click_2019,
            evh_6705964765214521_click,
            showWasteBinReadingModal: act_2248226175642056_showModal_2016,
            deleteItems: act_6705964765214521_request_2020,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], WasteBinReadings.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WasteBinReadings.prototype, "onSize", null);
WasteBinReadings = __decorate([
    (0, vue_property_decorator_1.Component)()
], WasteBinReadings);
exports.default = WasteBinReadings;
vue_property_decorator_1.Vue.component("WasteBinReadings", WasteBinReadings);
